import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import HardwareAssets from './Assets/HardwareAssets';
import SoftwareAssets from './Assets/SoftwareAssets';
import SystemAssets from './Assets/SystemAssets';
import PurchaseHistory from './Assets/PurchaseHistory';
import OnSiteAssets from './Assets/OnSiteAssets';
import ManageSiteAssets from './Assets/ManageSiteAssets';
import DisposedAssets from './Assets/DisposedAssets';
import AssetSettings from './Assets/AssetSettings';
import AssetDeclarationPage from './Assets/AssetDeclarationPage';
import AssetHodApprovalsPage from './Assets/AssetHodApprovalsPage';
import AssetDetails from './Assets/AssetDetails';

function Assets() {
  return (
    <Routes>
      <Route index element={<Navigate to="hardware" replace />} />
      <Route path="hod-approvals" element={<AssetHodApprovalsPage />} />
      <Route path="details/:id" element={<AssetDetails />} />
      <Route path="declaration" element={<AssetDeclarationPage />} />
      <Route path="hardware" element={<HardwareAssets />} />
      <Route path="software" element={<SoftwareAssets />} />
      <Route path="systems" element={<SystemAssets />} />
      <Route path="purchase_history" element={<PurchaseHistory />} />
      <Route path="onsite" element={<OnSiteAssets />} />
      <Route path="manage-site/:siteId" element={<ManageSiteAssets />} />
      <Route path="bin" element={<DisposedAssets />} />
      <Route path="settings" element={<AssetSettings />} />
      <Route path="*" element={<Navigate to="hardware" replace />} />
    </Routes>
  );
}

export default Assets;